import { modelMetaCacheTTL, brandShort } from '@/../app.config'
const SERVER_VERSION_KEY = `${brandShort}_server_version`
const MODELMETA_CACHE_PREFIX = 'modelmeta_'
const userCacheKey = (username) => `${MODELMETA_CACHE_PREFIX}${username}`

export const cacheServerVersion = (version) => {
  const cachedServerVersion = localStorage.getItem(SERVER_VERSION_KEY)
  if (cachedServerVersion !== version) {
    console.info('Server version changed')
    localStorage.setItem(SERVER_VERSION_KEY, version)
    clearModelMetaCache()
  }
}

export const cacheModelMeta = (modelMeta, username, currentTry = 1) => {
  const maxTry = 1
  const cacheKey = userCacheKey(username)
  const metaJson = JSON.stringify({ data: modelMeta, timestamp: Date.now() })
  try {
    localStorage.setItem(cacheKey, metaJson)
  } catch (e) {
    if (e.name === 'QuotaExceededError') {
      console.info('Clearing model meta cache due to quota exceeded')
      clearModelMetaCache()
    }
    if (currentTry < maxTry) {
      currentTry++
      cacheModelMeta(modelMeta, username, currentTry + 1)
    } else {
      console.info('Cound not cache model meta', e)
    }
  }
}

export const getCachedModelMeta = (username) => {
  const cacheKey = userCacheKey(username)
  let cachedMeta = null
  let cacheIsValid = false
  const cachedMetaData = localStorage.getItem(cacheKey)

  if (cachedMetaData) {
    const { data, timestamp } = JSON.parse(cachedMetaData)
    cacheIsValid = data ? Date.now() - timestamp < modelMetaCacheTTL : false
    cachedMeta = cacheIsValid ? data : null
    if (cacheIsValid && cachedMeta)
      console.info('Model meta recovered from from cache')
    if (!cacheIsValid) console.info('Model meta cache is outdated')
  }
  return { cachedMeta, cacheIsValid }
}

export const clearModelMetaCache = () => {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(MODELMETA_CACHE_PREFIX))
    .forEach((k) => localStorage.removeItem(k))
}
